var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceberg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 176,
    viewBox: "0 0 183 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9974 127.789L53.126 112.746L42.065 98.256L37.437 78.2652H146.017L130 119.383L120.82 124.913L106.917 156.192L96.7223 161.938L83.797 173.832L71.2662 155.11L66.5099 134.979L56.9974 127.789Z",
    fill: "#165B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7221 161.938L83.7969 173.832V78.2652H146.017L130 119.383L120.82 124.913L106.917 156.192L96.7221 161.938Z",
    fill: "#0F512B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5558 70.2759L37.437 78.2661H146.017L135.85 55.8995L123.714 47.0873L109.987 26.6974L100.525 35.3598L83.797 3.43945L67.1237 33.1261L52.8904 44.9195L48.6841 62.1466L38.5558 70.2759Z",
    fill: "#277146"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.525 35.3598L83.7969 3.43945V78.2661H146.017L135.85 55.8995L123.714 47.0873L109.987 26.6974L100.525 35.3598Z",
    fill: "#1D673C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5558 70.2759L37.437 78.2661H146.017L135.85 55.8995L123.714 47.0873L109.987 26.6974L100.525 35.3598L83.797 3.43945L67.1237 33.1261L52.8904 44.9195L48.6841 62.1466L38.5558 70.2759Z",
    stroke: "#83C67D",
    strokeWidth: 2.84667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9974 127.789L53.126 112.746L42.065 98.256L37.437 78.2652H146.017L130 119.383L120.82 124.913L106.917 156.192L96.7223 161.938L83.797 173.832L71.2662 155.11L66.5099 134.979L56.9974 127.789Z",
    stroke: "#83C67D",
    strokeWidth: 2.84667
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1982 78.2656L162.009 78.2656",
    stroke: "#83C67D",
    strokeWidth: 2.84667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43994 78.2656H12.2249",
    stroke: "#83C67D",
    strokeWidth: 2.84667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.665 78.2656H180.449",
    stroke: "#83C67D",
    strokeWidth: 2.84667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceberg);
export default __webpack_public_path__ + "static/media/iceberg.0d8ef99edcdf96ccc780152274fb5ba6.svg";
export { ForwardRef as ReactComponent };